export enum RouteNames {
  BOOKING_CONFIRMATION = 'confirmation',
  BOOKING_SUMMARY = 'details',
  CUSTOMER_DETAILS = 'account',
  FLEXIBLE_TICKETS = 'flexible',
  PAYG_TICKETS = 'payg',
  SEARCH_RESULT_TICKETS = 'results',
  TICKET_SELECTOR = 'select',
  TICKET_TYPES = 'types',
  DIRECT_DEBIT = 'pay',
  PAGE_NOT_FOUND = 'page-not-found',
  PAYMENT_FAILED = 'payment-failed',
  PAYMENT_SUCCESS = 'payment-success',
  POST_LOGIN = 'post-login',
}
